module.exports = __webpack_public_path__ + "static/media/empty-star.ea22cfd9.svg";